import FigureGridTile from "./FigureGridTile";
import figureService from "../../lib/figure";

export default function FigurePageIndex({ figures, header }) {
  return (
    <div>
      <h1>{header}</h1>
      <div className="grid grid-cols-2 md:grid-cols-6 xl:grid-cols-9 mt-10 gap-4 gap-y-10">
        {figures.map((figure) => {
          const name = figure.title;
          const portraitUrl = figureService.getPortraitUrl(figure);
          const portraitAlt = figureService.getPortraitAlt(figure);

          return (
            <FigureGridTile
              id={figure.id}
              slug={figure.slug}
              displayName={name}
              portraitUrl={portraitUrl}
              portraitAlt={portraitAlt}
              key={figure.id}
            />
          );
        })}
      </div>
    </div>
  );
}
